import React, { useState } from "react";
import Default from "@/Layouts/Default";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import LandingsPage from "@/Layouts/LandingsPage";

const exercises = [
    {
        title: "Bent-over reverse fly (Dumbell)",
        uuid: "5f8d6cb7-ed9e-446c-b06c-f8d1337a4037"
    },
    {
        title: "Bench press (Dumbell)",
        uuid: "a3099109-e012-4fc8-9aa8-32af58a1b51c"
    },
    {
        title: "45 Degree leg press",
        uuid: "81d1496a-2207-4efe-9512-bccace57a811"
    },
    {
        title: "Seated Leg Extension",
        uuid: "6b748a12-fa78-43d1-af1e-0899c41a3c51"
    },
    {
        title: "T-Bar Row- Barbell",
        uuid: "6b102c30-8f8c-46a7-925a-ed766db12e82"
    },
    {
        title: "Seated Leg Curl",
        uuid: "3cd4aac9-8b69-4e4d-9d5a-78bf4c2eb335"
    },
    {
        title: "Schuin Bandrukken - DBs",
        uuid: "e9e375c4-04ae-4e63-a53a-5ec3f17e2d7a"
    },
    {
        title: "Lat pull down brede grip",
        uuid: "d92a69d3-5ee0-4279-b58f-26fa17d2c796"
    },
    {
        title: "Hack Squat Machine",
        uuid: "c808e1f6-9613-4d36-889e-a21ded13bac3"
    },
    {
        title: "Butterfly inclined - DBs",
        uuid: "efb1b202-a7ee-418c-87e7-fb72ff7c93ef"
    },
    {
        title: "Horizontal row zittend - Pulley",
        uuid: "f9e5a9d7-c951-4477-b90e-7c7862a44647"
    },
    {
        title: "Butterfly - DBs",
        uuid: "75b1108e-fbb0-40d2-9071-04ee20f36675"
    },
    {
        title: "Bankdrukken - Barbell",
        uuid: "bde21cbb-7f15-4104-a311-192a0b329dbd",
    },
    {
        title: "Bent-over-row staand - Barbell",
        uuid: "bdc3e1f0-6b27-4a30-96e9-92a864e6ef28",
    },
    {
        title: "Biceps curl - Stang",
        uuid: "5cd9487e-c9a6-47fa-b2fc-3caddc1f5c4a",
    },
    {
        title: "Cross fly incline bench - Pulley",
        uuid: "024dba28-1c56-4683-aaef-520eabbe45ac",
    },
    {
        title: "Crossover - Pulley",
        uuid: "0bf8c85a-6fba-4506-bde0-5bd38d4bedad",
    },
    {
        title: "Deadlift - Trap Bar",
        uuid: "23894c69-119b-4b54-b24d-bf5f1dcdc9a5",
    },
    {
        title: "Lunge walk - DBs",
        uuid: "c0b93dca-3aad-478a-8cab-9f0fc08f4cce",
    },
    {
        title: "Shoulder press - Barbell",
        uuid: "546dcae7-88f7-428a-ac81-7148c60dcec7",
    },
    {
        title: "Squat - Barbell",
        uuid: "8417c309-040a-4bd3-ba5b-44f8213a95bb",
    },
    {
        title: "Triceps Pushdown - Rope",
        uuid: "cc43a543-7160-42e6-a20d-20e46000914e",
    },
].sort((a, b) => a.title.localeCompare(b.title));

const getItemsPerRow = () => {
    const width = window.innerWidth;
    if (width >= 1280) return 3; // xl
    if (width >= 1024) return 3; // lg
    if (width >= 768) return 2; // md
    if (width >= 640) return 2; // sm
    return 1; // xs
};

export default function Exercises() {
    const [searchTerm, setSearchTerm] = useState("");

    const filteredExercises = exercises.filter(exercise =>
        exercise.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <LandingsPage>
            <Head>
                <title>Oefeningen</title>
                <link rel="canonical" href={route("exercises")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Bekijk onze uitgebreide collectie van effectieve oefeningen voor personal training. Leer de juiste techniek voor optimale resultaten."
                />
                <meta
                    property="og:description"
                    content="Bekijk onze uitgebreide collectie van effectieve oefeningen voor personal training. Leer de juiste techniek voor optimale resultaten."
                />
                <meta property="og:url" content={route("exercises")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Oefeningen - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <div
                    className="relative xs:py-8 sm:py-8 md:py-16 lg:py-32 px-4 max-w-7xl mx-auto"
                    id="exercises-gallery"
                >
                    <div className="text-center mb-12">
                        <h1 className="text-white text-4xl md:text-5xl font-bold mb-4">
                            Oefeningen
                        </h1>
                        <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-8">
                            Bekijk onze uitgebreide collectie van effectieve oefeningen voor personal training
                        </p>
                        
                        {/* Search Input */}
                        <div className="max-w-md mx-auto">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Zoek oefeningen..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full px-4 py-3 pl-10 pr-4 text-white bg-gray-900 border border-gray-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 placeholder-gray-400 focus:outline-none focus:bg-gray-900"
                                    style={{
                                        backgroundColor: '#111827',
                                        color: '#ffffff',
                                        borderColor: '#374151'
                                    }}
                                />
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        
                        {/* Results count */}
                        {searchTerm && (
                            <p className="text-gray-400 text-sm mt-4">
                                {filteredExercises.length} van {exercises.length} oefeningen gevonden
                            </p>
                        )}
                    </div>
                    
                    <h2 id="gallery-heading" className="sr-only">
                        Oefeningen
                    </h2>
                    
                    {filteredExercises.length > 0 ? (
                        <div
                            role="list"
                            className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 sm:gap-x-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 xl:gap-x-8"
                        >
                            {filteredExercises.map((exercise, i) => (
                                <React.Fragment key={i}>
                                    <div className="relative ml-0 p-2 lg:px-4">
                                        <div className="mb-4 text-center px-2">
                                            <h3 className="text-white text-xl font-bold leading-tight">
                                                {exercise.title}
                                            </h3>
                                        </div>
                                        <div className="group block w-full aspect-w-9 aspect-h-16 rounded-lg bg-gray-800 overflow-hidden">
                                            <video
                                                className="w-full h-full object-cover"
                                                controls
                                                preload="metadata"
                                                src={`https://ucarecdn.com/${exercise.uuid}/`}
                                            >
                                                <source src={`https://ucarecdn.com/${exercise.uuid}/`} type="video/mp4" />
                                                <source src={`https://ucarecdn.com/${exercise.uuid}/`} type="video/webm" />
                                                <div className="flex items-center justify-center h-full bg-gray-800 text-white">
                                                    <div className="text-center">
                                                        <p>Video niet beschikbaar</p>
                                                        <p className="text-sm text-gray-400 mt-2">UUID: {exercise.uuid}</p>
                                                    </div>
                                                </div>
                                            </video>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-12">
                            <p className="text-gray-400 text-lg">
                                Geen oefeningen gevonden voor "{searchTerm}"
                            </p>
                            <button
                                onClick={() => setSearchTerm("")}
                                className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                            >
                                Toon alle oefeningen
                            </button>
                        </div>
                    )}
                </div>

                <Contact />
            </div>
        </LandingsPage>
    );
} 